@if (widgets.length > 0) {

  <div #gridEl class="grid-stack">

    @for (widget of widgets; track widget.id) {

      <div
        class="grid-stack-item"
        [attr.gs-id]="widget.id"
        [attr.gs-w]="widgetWidth(widget)"
      >
        <div class="grid-stack-item-content">
          <app-widget-switch
            [widget]="widget"
            [isStoreView]="isStoreView"
            (clickWidget)="actionWidget.emit(widget)"
          ></app-widget-switch>
        </div>
      </div>

    }

  </div>

}

@if (showEmptyMessage && widgets.length === 0) {

  <app-widgets-empty
    [isStoreView]="isStoreView"
    (setFavoritesWidgets)="setFavoritesWidgets.emit()"
  ></app-widgets-empty>

}
